import React from "react";
import { useMsal } from "../../../lib/msal-react";

import { loginRequest } from "../microsoftAuthConfig";
import { Button, Icon } from "antd";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 * Note the [useMsal] package
 */

export const SignInButton = ({ handleAuthClickMicrosoft }) => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance
      .loginPopup(loginRequest)
      .then(r => {
        // console.log(r);
        handleAuthClickMicrosoft(r);
      })
      .catch(e => {
        console.log(e);
      });
  };
  return (
    <Button
      type="primary"
      className="flex items-center justify-center px-4 py-2 mt-4 w-full text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:ring-opacity-50"
      onClick={handleLogin}
      icon="login"
    >
      Se connecter avec Microsoft
    </Button>
  );
};



// WEBPACK FOOTER //
// src/components/login/MicrosoftAuth/SignInButton.js